export const ACCESS_LEVELS = [
  { value: false, label: 'Read/Write' },
  { value: true, label: 'Read-only' },
];
